import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { ChevronRight } from '@withjoy/joykit/icons';

type ActionButtonProps = Readonly<{
  children: React.ReactNode;
  onClick?: () => void;
}>;

/**
 * Shared inner button component used within FixedActionButtonContainer.
 * Provides consistent styling for action buttons (Join Livestream, RSVP, View Guest Guide).
 */
export const ActionButton: React.FC<ActionButtonProps> = ({ children, onClick }) => {
  return (
    <ButtonV2
      variant="ghost"
      intent="neutral"
      shape="rounded"
      size="sm"
      height={8}
      paddingX={5}
      paddingY={3}
      borderRadius="full"
      backgroundColor="rgba(255, 255, 255, 0.8)"
      border="1px solid rgba(255, 255, 255, 0.50)"
      boxShadow="0 1px 2px rgba(0, 0, 0, 0.05)"
      typographyVariant="button1"
      onClick={onClick}
    >
      <Flex
        alignItems="center"
        gap={3}
      >
        {children}
        <ChevronRight
          size="sm"
          color="mono14"
        />
      </Flex>
    </ButtonV2>
  );
};
